import React from "react"
import {CalendarEventForm} from "sections/calendar/parts/EventPopup"
import {useModel} from "hooks"
import {RSVP} from "types/calendar"
import {OPTIONS_FREQUENCY, OPTIONS_FREQUENCY_TYPE} from "sections/calendar/parts/common"
import {PanelExpandedSection} from "uiKit/PanelExpandedSection"
import {Auth} from "types/auth"
import moment from "moment"

type DisplayPart = "list" | "create"

type Props = {
    calendarId: any
    student?: Auth.DepartmentStudent
    onNavigate?: (displayMode: DisplayPart) => void
}

const INITIAL_PERSONAL_EVENT_DATA = {
    publicId: "",
    name: "",
    typeEvent: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    rsvp: RSVP.Yes,
    recurring: OPTIONS_FREQUENCY[0],
    end: OPTIONS_FREQUENCY_TYPE[0],
    executions: "",
    every: "",
    days: {},
    monthlyRecurring: 0,
    monthDay: {},
    monthWeek: {},
    monthWeekDay: {},
    notes: "",
    allDay: false,
    rrule: undefined
}

export const CreateEvent = (props: Props) => {
    const {calendarId, student, onNavigate} = props
    const model = useModel()

    return (
        <PanelExpandedSection title="Calendar - Create Event" onClose={() => onNavigate("list")}>
            <CalendarEventForm
                model={model}
                calendarId={calendarId}
                onClose={() => onNavigate("list")}
                initialEventData={{
                    ...INITIAL_PERSONAL_EVENT_DATA,
                    hostUsers: [model.user],
                    invitedUsers: student ? [student] : [],
                    startDate: moment().add(1, "day"),
                    startTime: moment().add(1, "day").startOf("day").add(8, "hour"),
                    endTime: moment().add(1, "day").startOf("day").add(9, "hour")
                }}
                onCreateSuccess={() => {}}
                displayMode="panel"
            />
        </PanelExpandedSection>
    )
}
